import developmentLinks from './links/developmentLinks';
import stagingLinks from './links/stagingLinks';
import productionLinks from './links/productionLinks';

// eslint-disable-next-line import/no-mutable-exports
let Links: LinksProps;

//! fix me: need to update production/staging links

switch (process.env.NODE_ENV) {
  case 'staging':
    Links = stagingLinks;
    break;
  case 'production':
    Links = productionLinks;
    break;
  default:
    Links = developmentLinks;
    break;
}

export interface LinksProps {
  tradeIn: {
    url: string;
  };
  testDrive: {
    url: string;
  };
  contactDealer: {
    url: string;
  };
  formsUsedBookATestDrive?: {
    en: string;
    fr: string;
  };
}

export default Links;
